/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatientCommonExpression } from './PatientCommonExpression';
import {
    PatientCommonExpressionFromJSON,
    PatientCommonExpressionFromJSONTyped,
    PatientCommonExpressionToJSON,
    PatientCommonExpressionToJSONTyped,
} from './PatientCommonExpression';
import type { UiIdentifier } from './UiIdentifier';
import {
    UiIdentifierFromJSON,
    UiIdentifierFromJSONTyped,
    UiIdentifierToJSON,
    UiIdentifierToJSONTyped,
} from './UiIdentifier';

/**
 * Expression-CCL link enriched with resolved expression data and UI fields
 * @export
 * @interface ExprCcl
 */
export interface ExprCcl {
    /**
     * 
     * @type {string}
     * @memberof ExprCcl
     */
    relationshipId?: string;
    /**
     * 
     * @type {number}
     * @memberof ExprCcl
     */
    expressionCclId: number;
    /**
     * 
     * @type {number}
     * @memberof ExprCcl
     */
    conclusionGroupId: number;
    /**
     * 
     * @type {number}
     * @memberof ExprCcl
     */
    expressionId: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExprCcl
     */
    isMarked: boolean;
    /**
     * 
     * @type {number}
     * @memberof ExprCcl
     */
    expressionOrder: number;
    /**
     * Absolute row position in the CsList grid
     * @type {number}
     * @memberof ExprCcl
     */
    row: number;
    /**
     * Display text for the proxy button (matchedText, or originalText as fallback)
     * @type {string}
     * @memberof ExprCcl
     */
    buttonText: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExprCcl
     */
    buttonMatched: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExprCcl
     */
    isResultDocument: boolean;
    /**
     * ui string of the item immediately above (for keyboard navigation)
     * @type {string}
     * @memberof ExprCcl
     */
    topUi: string;
    /**
     * 
     * @type {UiIdentifier}
     * @memberof ExprCcl
     */
    id: UiIdentifier;
    /**
     * originalText
     * @type {string}
     * @memberof ExprCcl
     */
    text: string;
    /**
     * originalText copy kept for front-end dirty-check
     * @type {string}
     * @memberof ExprCcl
     */
    dbText: string;
    /**
     * 
     * @type {PatientCommonExpression}
     * @memberof ExprCcl
     */
    expression?: PatientCommonExpression;
}

/**
 * Check if a given object implements the ExprCcl interface.
 */
export function instanceOfExprCcl(value: object): value is ExprCcl {
    if (!('expressionCclId' in value) || value['expressionCclId'] === undefined) return false;
    if (!('conclusionGroupId' in value) || value['conclusionGroupId'] === undefined) return false;
    if (!('expressionId' in value) || value['expressionId'] === undefined) return false;
    if (!('isMarked' in value) || value['isMarked'] === undefined) return false;
    if (!('expressionOrder' in value) || value['expressionOrder'] === undefined) return false;
    if (!('row' in value) || value['row'] === undefined) return false;
    if (!('buttonText' in value) || value['buttonText'] === undefined) return false;
    if (!('buttonMatched' in value) || value['buttonMatched'] === undefined) return false;
    if (!('isResultDocument' in value) || value['isResultDocument'] === undefined) return false;
    if (!('topUi' in value) || value['topUi'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('dbText' in value) || value['dbText'] === undefined) return false;
    return true;
}

export function ExprCclFromJSON(json: any): ExprCcl {
    return ExprCclFromJSONTyped(json, false);
}

export function ExprCclFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExprCcl {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'] == null ? undefined : json['relationshipId'],
        'expressionCclId': json['expressionCclId'],
        'conclusionGroupId': json['conclusionGroupId'],
        'expressionId': json['expressionId'],
        'isMarked': json['isMarked'],
        'expressionOrder': json['expressionOrder'],
        'row': json['row'],
        'buttonText': json['buttonText'],
        'buttonMatched': json['buttonMatched'],
        'isResultDocument': json['isResultDocument'],
        'topUi': json['topUi'],
        'id': UiIdentifierFromJSON(json['id']),
        'text': json['text'],
        'dbText': json['dbText'],
        'expression': json['expression'] == null ? undefined : PatientCommonExpressionFromJSON(json['expression']),
    };
}

export function ExprCclToJSON(json: any): ExprCcl {
    return ExprCclToJSONTyped(json, false);
}

export function ExprCclToJSONTyped(value?: ExprCcl | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'expressionCclId': value['expressionCclId'],
        'conclusionGroupId': value['conclusionGroupId'],
        'expressionId': value['expressionId'],
        'isMarked': value['isMarked'],
        'expressionOrder': value['expressionOrder'],
        'row': value['row'],
        'buttonText': value['buttonText'],
        'buttonMatched': value['buttonMatched'],
        'isResultDocument': value['isResultDocument'],
        'topUi': value['topUi'],
        'id': UiIdentifierToJSON(value['id']),
        'text': value['text'],
        'dbText': value['dbText'],
        'expression': PatientCommonExpressionToJSON(value['expression']),
    };
}

